import AbstractMain from 'frontools/abstract/AbstractMain';
import Breakpoint from 'frontools/core/Breakpoint';

import AbstractPage from './pages/AbstractPage';
import { Accueil } from './pages/Accueil';
import { Projet } from './pages/Projet';
import { Services } from './pages/Services';
// import RouteManager from './route.manager';
import { RouteManagerEvents } from './route.manager';
import ExtendRouteManager from './extendroute.manager';

export class Main extends AbstractMain {

    public breakpoint               : Breakpoint;

    private _page                   : AbstractPage;

    constructor(context:Object = {}) {
        super(context);

        // let routeManager = new ExtendRouteManager();
        // routeManager.addListener(RouteManagerEvents.AFTER_LOAD, this._onRouteLoaded.bind(this));
        // routeManager.debug = true;

        this._onRouteLoaded();

        Breakpoint.trigger();    
    }

    private _onRouteLoaded() {
        let body = document.body;   
        if (body.classList.contains('p_accueil') || body.classList.contains('p_categorie') || body.classList.contains('p_createur')) {
            this._page = new Accueil(body.className);
        } else if (body.classList.contains('p_projet')) {       
            this._page = new Projet();
        } else if (body.classList.contains('p_services')){
            this._page = new Services(); 
        } else {
            // If no page js present, create basic abstract page
            this._page = new AbstractPage();         
        }
    }

     /*
    * Override breakpoints init to add new groups
    */
    protected initBreakpoint() {
        this.breakpoint = new Breakpoint({
            debug: true,
            breakpoints: [
                Breakpoint.MOBILES = 'mobiles',
                Breakpoint.MOBILE = 'mobile',
                Breakpoint.TABLETP = 'tabletp',
                Breakpoint.TABLET = 'tablet',
                Breakpoint.DESKTOP = 'desktop',
                Breakpoint.LARGE = 'large',
                Breakpoint.HD = 'hd'
            ],  
            groups: {
                'group_mobile': [
                    Breakpoint.MOBILES, 
                    Breakpoint.MOBILE,
                    Breakpoint.TABLETP
                ],
                'group_desktop': [
                    Breakpoint.TABLET,
                    Breakpoint.DESKTOP,
                    Breakpoint.LARGE,
                    Breakpoint.HD
                ],
                'group_small': [
                    Breakpoint.MOBILES,
                    Breakpoint.MOBILE,
                    Breakpoint.TABLETP,
                    Breakpoint.TABLET
                ],
                'group_large': [
                    Breakpoint.DESKTOP,
                    Breakpoint.LARGE,
                    Breakpoint.HD
                ],
            }
        });
    }

}